import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"

/**
 * Loading skeleton installer create application page
 */
const CreateApplicationSkeleton = (): ReactElement => (
    <div data-testid="loading-skeleton">
        <Stack spacing={GRID_SPACING} justifyContent="flex-start" height="100%">
            <AppSkeleton height="100px" variant="rectangular" />
            <AppSkeleton height="100%" variant="rectangular" />
        </Stack>
    </div>
)
export default CreateApplicationSkeleton
